import React, { memo } from 'react'

import { bool, func } from 'prop-types'

import AdvancedFiltersContent from 'Pods/SearchPage/Shared/AdvancedFiltersContent/AdvancedFiltersContent'
import { SECTION } from 'Pods/SearchPage/Shared/AdvancedFiltersContent/constants'
import DatePublishedContent from 'Pods/SearchPage/Shared/DatePublishedContent/DatePublishedContent'
import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import PopoverFeaturesContent from 'Pods/SearchPage/Shared/PopoverFeaturesContent/PopoverFeaturesContent'
import QualityContent from 'Pods/SearchPage/Shared/QualityContent/QualityContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { ASSET_TYPE, DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import { NOOP } from 'Utils/stableDefaults'

import Section from './Components/Section/Section'

// Figma 3183:36396 (1440+): License / Status / Other | Designer | Date published. Quality (below
// 1440, Figma 415:19987 "1280+") or Features (3D Only, Figma 3183:42085) add a second filter column:
// Quality / License | Status / Other / Features. Designer leaves from xl, where it has its own row 1
// dropdown.
function Columns({ showQuality = false, showDesigner = true, onDateRangeApply = NOOP }) {
  const translate = useTranslate()

  const isCustomRange = useSearchPageStore(state => state.datePublished === DATE_PUBLISHED.CUSTOM)
  const is3DOnly = useSearchPageStore(state => state.assetType === ASSET_TYPE.THREE_D_ONLY)
  // Status is actor-only (see AdvancedFiltersContent); skip its empty section when signed out.
  const pageConfig = usePageConfig()
  const isLoggedIn = !!pageConfig?.currentUserId
  const hasSecondColumn = showQuality || is3DOnly

  const statusSection = isLoggedIn && (
    <Section className="more-filters__group--status">
      <AdvancedFiltersContent section={SECTION.STATUS} />
    </Section>
  )
  const otherSection = (
    <Section>
      <AdvancedFiltersContent section={SECTION.GENERAL} />
    </Section>
  )

  return (
    <div className="more-filters__columns">
      <div className="more-filters__column">
        {showQuality && (
          <Section title={translate('search_page.filters.quality.title')}>
            <QualityContent />
          </Section>
        )}
        <Section title={translate('search_page.filters.license.title')}>
          <LicenseContent />
        </Section>
        {!showQuality && statusSection}
        {!hasSecondColumn && otherSection}
      </div>
      {hasSecondColumn && (
        <div className="more-filters__column">
          {showQuality && statusSection}
          {otherSection}
          {is3DOnly && (
            <Section>
              <PopoverFeaturesContent />
            </Section>
          )}
        </div>
      )}
      {showDesigner && (
        <div className="more-filters__column more-filters__column--designer">
          <Section
            title={translate('search_page.filters.designers.title')}
            className="more-filters__group--fill"
          >
            {/* The popover's footer Reset clears designers, so the section hides its own. The list
                scrolls on its own so a long one does not stretch every column. */}
            <DesignerContent hideReset isListScrollable />
          </Section>
        </div>
      )}
      <div
        className={isCustomRange
          ? 'more-filters__column more-filters__column--date more-filters__column--calendar'
          : 'more-filters__column more-filters__column--date'}
      >
        <Section
          title={translate('search_page.filters.date_published.title')}
          className={isCustomRange ? 'more-filters__group--calendar' : ''}
        >
          <DatePublishedContent autoApply showApply onApply={onDateRangeApply} />
        </Section>
      </div>
    </div>
  )
}

Columns.propTypes = {
  showQuality: bool,
  showDesigner: bool,
  onDateRangeApply: func,
}

export default memo(Columns)
